import {
  Box,
  Button,
  MenuItem,
  Select,
  Typography,
  TextField,
  InputAdornment,
} from '@mui/material';
import { MagnifyingGlassIcon } from '@phosphor-icons/react';
import { useState, useEffect } from 'react';
import LayoutWithSidebar from '../../components/common/layoutWithSidebar';
import { HeaderContainer } from '../../components/dashboard/AgentInfoHeader';
import { useStores } from '../../hooks/useStores';
import PublishHistoryDrawer from './PublishHistoryDrawer';
import MenuLayout from '../../components/KnowledgeBase/MenuConfig/MenuLayout';
import { useUser } from '../../hooks/useUser';
import theme from '../../theme';

const RestaurantMenuConfig = ({
  store,
  fromStoreDetails = false,
  searchQuery: externalSearchQuery = '',
}: {
  store?: any;
  fromStoreDetails?: boolean;
  searchQuery?: string;
}) => {
  const { user } = useUser();
  const { data: stores } = useStores(user?.tenantName || '');
  const [isHistoryDrawerOpen, setIsHistoryDrawerOpen] = useState(false);
  const [selectedStore, setSelectedStore] = useState<any>(null);
  const [searchQuery, setSearchQuery] = useState('');

  console.log(stores?.data?.stores);

  // Use external search query when provided (from StoreDetailsTabs)
  const activeSearchQuery = fromStoreDetails
    ? externalSearchQuery
    : searchQuery;

  // Set the selected store when stores data is loaded
  useEffect(() => {
    if (stores?.data?.stores?.length > 0) {
      setSelectedStore(stores?.data?.stores[0]);
    }
  }, [stores]);

  const handleStoreChange = (value: any) => {
    const selectedStore = stores?.data?.stores?.find(
      (store: any) => store.friendly_name === value
    );
    setSelectedStore(selectedStore);
  };

  return (
    <>
      {!fromStoreDetails ? (
        <LayoutWithSidebar margin={2}>
          <HeaderContainer>
            <Typography
              sx={{
                fontFamily: 'DM Sans',
                fontWeight: 600,
                fontSize: '24px',
                lineHeight: '100%',
                letterSpacing: '-0.01em',
                color: '#2B2D3F',
              }}
            >
              Restaurant Menu
            </Typography>

            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <Typography
                  fontSize={12}
                  fontWeight={400}
                  color="text.secondary"
                >
                  View Menu For:
                </Typography>
                <Select
                  sx={{
                    width: 'fit-content',
                    '& .MuiSelect-select': {
                      display: 'flex',
                      padding: '8px 16px',
                      alignItems: 'center',
                      borderRadius: '6px',
                      border: '1px solid #DCE0E7',
                      background: '#F8F9FC',
                      fontWeight: 400,
                      lineHeight: 'normal',
                      letterSpacing: '-0.14px',
                      color: theme.palette.lightGray.text,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                  }}
                  value={selectedStore?.friendly_name || ''}
                  onChange={(e: any) => handleStoreChange(e.target.value)}
                  displayEmpty
                >
                  {stores?.data?.stores?.map((store: any) => (
                    <MenuItem key={store.id} value={store.friendly_name}>
                      {store.friendly_name}
                    </MenuItem>
                  ))}
                </Select>
              </Box>

              <TextField
                placeholder="Search menu items..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                size="small"
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <MagnifyingGlassIcon size={20} />
                      </InputAdornment>
                    ),
                  },
                }}
                sx={{
                  width: '300px',
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#F8F9FC',
                    borderRadius: '6px',
                    '& fieldset': {
                      borderColor: '#DCE0E7',
                    },
                    '&:hover fieldset': {
                      borderColor: '#DCE0E7',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'primary.main',
                    },
                  },
                }}
              />

              <Button
                color="primary"
                sx={{ textTransform: 'none', boxShadow: 'none' }}
                onClick={() => setIsHistoryDrawerOpen(true)}
              >
                Publish History
              </Button>
            </Box>
          </HeaderContainer>
          <Box sx={{ height: 'calc(100vh - 120px)' }}>
            <MenuLayout
              selectedStore={selectedStore || store}
              searchQuery={activeSearchQuery}
            />
          </Box>
          <PublishHistoryDrawer
            open={isHistoryDrawerOpen}
            onClose={() => setIsHistoryDrawerOpen(false)}
            selectedStore={selectedStore}
          />
        </LayoutWithSidebar>
      ) : (
        <>
          <Box sx={{ height: 'calc(100vh - 120px)' }}>
            <MenuLayout
              selectedStore={fromStoreDetails ? store : selectedStore}
              fromStoreDetails={fromStoreDetails}
              searchQuery={activeSearchQuery}
            />
          </Box>
          <PublishHistoryDrawer
            open={isHistoryDrawerOpen}
            onClose={() => setIsHistoryDrawerOpen(false)}
            selectedStore={selectedStore}
          />
        </>
      )}
    </>
  );
};

export default RestaurantMenuConfig;
